import { getProjectPictureUrl } from '../utils/cloudinary';

export const stringToProjectModalImage = (picture: string): string => {
    // Returns optimized Cloudinary URL for project pictures
    // The picture parameter should match the image name in Cloudinary (without extension)
    if (!picture) return "";
    return getProjectPictureUrl(picture);
};
